import * as generic from "@/store/generic/mutations/result-status.js";

export const setError = generic.setError;
export const setSuccess = generic.setSuccess;
export const setProcessing = generic.setProcessing;

export function storeChatrooms(state, data) {
  state.chatrooms[data.id] = data;
}

export function purgeClassroom(state) {
  state.chatrooms = {};
}
